import { useEffect } from 'react';
import Layout from '../../../components/layout/Layout';
import Breadcrumb from '../../../components/layout/Breadcrumb';
import { updateSEO } from '../../../utils/seo';

// ===== Professional Butler 詳細ページ 全面最新化（Implementer B スコープ） =====
// デザイン土台（型正典）: src/pages/about/overview/page.tsx / src/pages/home/page.tsx（紺#1a2942 / 真鍮金#a38e65 /
//   金差し色#d7b779 / BTN-08 2状態 / 金eyebrow→金差し色見出し→真鍮短罫 / リード3行+ / 装飾ディバイダー禁止）。
// 事実正典（創作禁止・実データ変更禁止・出典path記録）:
//   [S-cur] 旧 src/pages/qualifications/professional-butler/page.tsx（全12章・料金78,000円・試験要項の実データ）
//   [S-canon] mng-thebutler/00_事業説明.md L63（三段階資格 Associate/Professional/Master）
//   [S-overview] src/pages/about/overview/page.tsx（BTN08・セクション文法）

const BTN08_ON_NAVY = "relative inline-flex items-center justify-center bg-[#a38e65] text-white font-semibold border border-[#1a2942] px-[42px] py-[16px] text-sm tracking-[0.2em] font-['Noto_Serif_JP',serif] transition-colors duration-300 hover:bg-[#1a2942] hover:text-[#f8f6f0] hover:border-[#a38e65] cursor-pointer whitespace-nowrap before:content-[''] before:absolute before:inset-1 before:border before:border-[#1a2942]/40 before:pointer-events-none before:transition-colors before:duration-300 hover:before:border-[#a38e65]/50";

const curriculum = [
  { n: '01', t: 'Associate Butler の復習と発展', d: '基礎知識を確認し、Professional Butler レベルへの橋渡しを行います。これまでの学習がどう実践に活かされるかを理解し、より高度な学習へのマインドセットを整えます。' },
  { n: '02', t: '上級テーブルサービス', d: 'フォーマルディナーの完璧なサービス技術。テーブルセッティング、コース料理の提供手順、サービス動線の設計、複数ゲストへの同時対応など、高度なテーブルサービスを習得します。' },
  { n: '03', t: '高度な接客サービス技術', d: 'さまざまな場面でのサービス提供。来客対応、電話応対、案内誘導の実践、細やかな配慮とタイミング、先を読んだ準備など、プロフェッショナルなサービス技術を磨きます。' },
  { n: '04', t: '邸宅管理の実践', d: '住環境の総合的な管理。日常清掃から定期メンテナンス、家具・調度品のケア、衣類管理、季節ごとの業務など、邸宅を適切に維持する実践的スキルを学びます。' },
  { n: '05', t: 'VIP対応の実践', d: '富裕層への高品質なサービス。ニーズの先読み、プライバシーと機密保持、特別な要望への柔軟な対応、高いレベルの期待に応える実践力を習得します。' },
  { n: '06', t: '問題解決と意思決定', d: '予期せぬ事態への対処法。トラブルの予防、問題の分析と解決、冷静な判断力、優先順位の設定、代替案の提示など、的確な意思決定能力を養います。' },
  { n: '07', t: 'クレーム対応の実践', d: '苦情やクレームへの適切な対処。基本姿勢、傾聴と共感、冷静な対応、解決策の提案、再発防止など、信頼回復のための実践的スキルを学びます。' },
  { n: '08', t: 'イベント・パーティー運営', d: '催事の企画から実施まで。ホームパーティーの企画、ゲスト対応、会場設営、進行管理、チーム調整など、イベントを成功させる運営力を習得します。' },
  { n: '09', t: 'リーダーシップの基礎', d: 'チームをまとめる統率力。リーダーの役割、コミュニケーション、スタッフへの指示と調整、モチベーション管理、協力体制の構築など、リーダーシップの基本を学びます。' },
  { n: '10', t: '国際プロトコル入門', d: '国際儀礼の基本。各国の文化と習慣、外国人ゲストへの対応、宗教的配慮、グローバルな視点でのサービス提供など、国際感覚を養います。' },
  { n: '11', t: 'ビジネススキル基礎', d: '業務遂行に必要な基本スキル。スケジュール管理、文書作成、会議設営、報告書作成、ビジネスマナーなど、執事に求められる実務能力を習得します。' },
  { n: '12', t: '総合実践演習', d: '複合的なケーススタディと実技シミュレーション。学んだ知識とスキルを統合し、実践力を確認します。試験対策としても重要な章です。' },
];

const recommended = [
  'Associate Butler 資格を取得済みの方',
  '独立して高品質なサービスを提供したい方',
  '問題解決力と判断力を身につけたい方',
  'リーダーシップを発揮したい方',
  '高級ホテルや個人邸宅でのキャリアアップを目指す方',
  'VIP対応の実践力を磨きたい方',
  '将来 Master Butler を目指している方',
];

const materials = [
  { t: 'テキスト教材（約200ページ）', d: '実践的な専門知識を詳しく解説した専用テキスト。ケーススタディを多く収め、現場での判断力を養います。' },
  { t: 'オンライン動画レッスン', d: '実技を含む分かりやすい動画解説。高度なサービス技術の実演など、動画だからこそ伝わる内容が満載です。視聴期間は1年間。' },
  { t: '実技練習用キット', d: '学習をサポートする練習用グッズをお届けします。上級のサービス技術を自宅でも練習できます。' },
  { t: '認定試験問題・解答用紙', d: '実践的なケーススタディを含む試験問題。返送後、当協会が添削・採点します。' },
];

const examRows = [
  ['試験形式', '筆記試験（記述式・選択式・ケーススタディ）'],
  ['合格基準', '80点以上'],
  ['試験期限', '申込から1年以内に提出'],
  ['受験資格', 'Associate Butler 資格保持者のみ'],
  ['受験場所', '自宅（通信試験）'],
  ['再試験', '不合格の場合、再試験料15,000円で何度でも再挑戦可能'],
];

const ladder = [
  { key: 'associate', roman: 'I', name: 'Associate Butler', ja: 'アソシエイト・バトラー', price: '48,000', level: '初級', href: '/qualifications/associate-butler' },
  { key: 'professional', roman: 'II', name: 'Professional Butler', ja: 'プロフェッショナル・バトラー', price: '78,000', level: '中級', href: '/qualifications/professional-butler' },
  { key: 'master', roman: 'III', name: 'Master Butler', ja: 'マスター・バトラー', price: '128,000', level: '上級', href: '/qualifications/master-butler' },
];

function SecHead({ roman, en, children }: { roman: string; en: string; children: React.ReactNode }) {
  return (
    <div className="mb-9">
      <div className="-mx-5 sm:-mx-8 mb-6 bg-[#1a2942] border-y border-[#a38e65]/25 px-5 sm:px-8 py-[18px]">
        <span className="block font-['Playfair_Display',serif] uppercase tracking-[0.28em] text-xs text-[#d7b779]">{roman}. {en}</span>
      </div>
      <h2 className="jba-display font-medium text-[#1a2942] text-2xl sm:text-3xl lg:text-[31px] leading-[1.5] tracking-[0.02em]">{children}</h2>
    </div>
  );
}

export default function ProfessionalButlerPage() {
  useEffect(() => {
    updateSEO({
      title: 'Professional Butler（プロフェッショナル・バトラー）｜執事の実践力を証明する中級資格 | 全日本執事協会',
      description: '全日本執事協会認定 Professional Butler は、独立して質の高いサービスを提供できる実践力を証明する中級資格です。VIP対応・邸宅管理・問題解決・リーダーシップを全12章で習得。料金78,000円、Associate Butler 保持者が対象。執事サロン3時間無料体験付き。',
      keywords: 'Professional Butler,プロフェッショナル・バトラー,執事資格,中級資格,執事検定,VIP対応,全日本執事協会',
      canonical: 'https://butler-association.jp/qualifications/professional-butler',
    });
  }, []);

  const breadcrumbs = [
    { label: 'ホーム', href: '/' },
    { label: '執事資格制度', href: '/qualifications' },
    { label: 'Professional Butler' },
  ];

  return (
    <Layout>
      <section className="relative bg-[#1a2942] overflow-hidden min-h-[540px] lg:min-h-[620px] flex items-center">
        <img
          src="/images/generated/jba-hands-cufflink-01.webp"
          alt="白手袋とカフリンクス。プロフェッショナルの所作"
          className="absolute inset-0 w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-[linear-gradient(90deg,rgba(16,20,26,0.93)_0%,rgba(16,20,26,0.74)_48%,rgba(16,20,26,0.36)_100%)]"></div>
        <div className="relative z-10 w-full max-w-[1200px] mx-auto px-5 sm:px-8 pt-32 pb-16 lg:pt-36 lg:pb-20">
          <div className="max-w-[680px]">
            <span className="block font-['Playfair_Display',serif] uppercase tracking-[0.32em] text-xs sm:text-[13px] text-[#d7b779] mb-4">Professional Butler ・ Level II</span>
            <div className="w-12 h-px bg-[#a38e65] mb-6"></div>
            <h1 className="jba-display font-normal text-white text-[clamp(28px,3.4vw,44px)] leading-[1.4] tracking-[0.04em] mb-3">
              独り立ちする、<span className="text-[#d7b779]">Professional Butler</span>
            </h1>
            <p className="font-['Noto_Serif_JP',serif] text-[#e7e2d8] text-sm tracking-[0.14em] mb-6">プロフェッショナル・バトラー ／ 中級資格</p>
            <p className="font-['Noto_Serif_JP',serif] text-base sm:text-lg text-white/90 leading-[1.95] mb-8">
              Associate Butler で培った基礎の上に、実務で求められる高度な専門知識と技術を積み上げる中級資格です。状況を判断し最適な対応を選ぶ力、複雑な問題を解決する力、チームをまとめるリーダーシップまで、独立して質の高いサービスを提供するために必要な力を体系的に身につけます。
            </p>
            <div className="flex flex-wrap items-end gap-x-8 gap-y-3">
              <div>
                <span className="block font-['Playfair_Display',serif] uppercase tracking-[0.2em] text-[10px] text-[#d7b779] mb-1">Fee</span>
                <span className="jba-display text-white text-[26px] sm:text-[28px] leading-none">78,000<span className="text-base text-[#d7b779] ml-1">円</span></span>
                <span className="block font-['Noto_Serif_JP',serif] text-[11px] text-white/60 mt-1">税込・送料込</span>
              </div>
              <a href="/contact" className={BTN08_ON_NAVY}>受講を申し込む</a>
            </div>
          </div>
        </div>
      </section>

      {/* パンくず: ビルボード直後に配置（Yuichi 2026-07-17 指摘②）。共通Breadcrumbのヘッダー逃げpaddingを子セレクタで通常paddingへ上書き */}
      <div className="bg-white [&>div]:!pt-6">
        <Breadcrumb items={breadcrumbs} />
      </div>

      <div className="bg-white">
        <div className="max-w-[1200px] mx-auto px-5 sm:px-8 py-14 sm:py-18 lg:py-20 space-y-16 sm:space-y-20">

          <section>
            <SecHead roman="I" en="About This Certification">実務に応える、<span className="text-[#a38e65]">応用の力</span></SecHead>
            <div className="space-y-[18px] font-['Noto_Serif_JP',serif] text-base text-[#333] leading-[1.95] max-w-3xl">
              <p>Professional Butler 資格は、Associate Butler で学んだ基礎をさらに発展させ、実務で求められる高度な専門知識と技術を習得する中級資格です。単なる作業の実行ではなく、状況を判断し最適な対応を選択できる能力、複雑な問題を解決する力、他のスタッフをまとめるリーダーシップなど、プロフェッショナルとして自立するために必要なスキルを体系的に学びます。</p>
              <p>この資格では、実際の場面を想定したケーススタディを多用し、理論だけでなく実践的な判断力を養います。邸宅管理、イベント運営、VIP対応、クレーム処理など、多様なシチュエーションに対応できる応用力を身につけます。</p>
              <p>独立して高品質なサービスを提供できる執事を目指すかたにとって、確かな中核となる資格です。取得後は、最高位の Master Butler への道も拓かれます。</p>
            </div>
            <dl className="grid grid-cols-2 md:grid-cols-4 gap-y-6 gap-x-4 mt-10 border-t border-[#e2ddd2] pt-8">
              <div>
                <dt className="font-['Noto_Serif_JP',serif] text-xs text-[#8f7a56] tracking-[0.06em] mb-1.5">料金</dt>
                <dd className="jba-display text-[#1a2942] text-[26px] leading-none">78,000<span className="text-sm text-[#8f7a56] ml-1">円</span></dd>
              </div>
              <div>
                <dt className="font-['Noto_Serif_JP',serif] text-xs text-[#8f7a56] tracking-[0.06em] mb-1.5">テキスト</dt>
                <dd className="font-['Playfair_Display',serif] text-2xl text-[#1a2942]">約200<span className="text-sm text-[#8f7a56] ml-1">頁</span></dd>
              </div>
              <div>
                <dt className="font-['Noto_Serif_JP',serif] text-xs text-[#8f7a56] tracking-[0.06em] mb-1.5">学習期間目安</dt>
                <dd className="font-['Playfair_Display',serif] text-2xl text-[#1a2942]">4–6<span className="text-sm text-[#8f7a56] ml-1">ヶ月</span></dd>
              </div>
              <div>
                <dt className="font-['Noto_Serif_JP',serif] text-xs text-[#8f7a56] tracking-[0.06em] mb-1.5">受験資格</dt>
                <dd className="font-['Noto_Serif_JP',serif] text-base text-[#1a2942] leading-tight pt-1">Associate 保持者</dd>
              </div>
            </dl>
          </section>

          <section>
            <SecHead roman="II" en="Why Professional">現場で通用する、<span className="text-[#a38e65]">三つの力</span></SecHead>
            <div className="grid md:grid-cols-3 gap-x-10 gap-y-8">
              {[
                { no: '01', en: 'Advanced Skill', ja: '高度な実践力', d: '基礎を超えた専門技術を習得し、独立して質の高いサービスを提供できるレベルへ引き上げます。' },
                { no: '02', en: 'Judgment', ja: '問題解決力', d: '予期せぬ事態にも冷静に対応。状況を分析し、最適な判断を選び取る応用的な思考力を養います。' },
                { no: '03', en: 'Leadership', ja: 'リーダーシップ', d: 'チームをまとめ、他のスタッフを導く統率力。現場全体のサービス品質を高める力を身につけます。' },
              ].map((f) => (
                <div key={f.no} className="border-t border-[#e2ddd2] pt-6">
                  <span className="font-['Playfair_Display',serif] text-[#d7b779] text-3xl leading-none block mb-3">{f.no}</span>
                  <span className="block font-['Playfair_Display',serif] italic text-[#8f7a56] text-[13px] tracking-[0.06em] mb-1">{f.en}</span>
                  <h3 className="jba-display font-medium text-[#1a2942] text-lg sm:text-xl mb-2.5 leading-[1.5]">{f.ja}</h3>
                  <p className="font-['Noto_Serif_JP',serif] text-sm text-[#4a4638] leading-[1.9]">{f.d}</p>
                </div>
              ))}
            </div>
          </section>

          <section>
            <SecHead roman="III" en="Curriculum ・ 12 Chapters">全12章で磨く、<span className="text-[#a38e65]">実践の技術</span></SecHead>
            <p className="font-['Noto_Serif_JP',serif] text-base text-[#333] leading-[1.95] max-w-3xl mb-8">
              Professional Butler では、実践的なサービス技術と判断力、リーダーシップを12の分野で学びます。ケーススタディを軸に、現場で求められる応用力を確かなものにします。
            </p>
            <img
              src="/images/generated/jba-fs-174-qualifications_professional-butler-v7.webp"
              alt="Professional Butler の学習教材。実践的なケーススタディを収めたテキスト"
              className="w-full aspect-[21/9] h-auto object-cover object-center border border-[#a38e65]/30 mb-10"
            />
            <div className="grid md:grid-cols-2 gap-x-10 gap-y-8">
              {curriculum.map((c) => (
                <div key={c.n} className="flex gap-5 border-t border-[#e2ddd2] pt-6">
                  <span className="font-['Playfair_Display',serif] text-[#d7b779] text-3xl leading-none shrink-0 pt-1">{c.n}</span>
                  <div>
                    <h3 className="jba-display font-medium text-[#1a2942] text-lg mb-2.5 leading-[1.5]">{c.t}</h3>
                    <p className="font-['Noto_Serif_JP',serif] text-sm text-[#4a4638] leading-[1.9]">{c.d}</p>
                  </div>
                </div>
              ))}
            </div>
          </section>

          {/* IV. こんなかたに（細罫2カラムリスト型）= 新バリエーション①。由来注記: overview S2 定義リストdl文法をチェック項目列挙へ翻案 */}
          <section>
            <SecHead roman="IV" en="Recommended For">こんなかたに、<span className="text-[#a38e65]">おすすめです</span></SecHead>
            <ul className="grid sm:grid-cols-2 gap-x-10 border-t-2 border-[#1a2942]">
              {recommended.map((r) => (
                <li key={r} className="flex items-start gap-3 border-b border-[#e2ddd2] py-4">
                  <span className="text-[#a38e65] text-[13px] leading-none pt-1.5" aria-hidden="true">◆</span>
                  <span className="font-['Noto_Serif_JP',serif] text-[15px] text-[#1a2942] leading-[1.8]">{r}</span>
                </li>
              ))}
            </ul>
          </section>

          {/* V. 教材（積層splitカード型）= 新バリエーション②。由来注記: カタログ SEC-N04 積層カード文法 */}
          <section>
            <SecHead roman="V" en="Course Materials">お手元に届く、<span className="text-[#a38e65]">学びの一式</span></SecHead>
            <div className="grid md:grid-cols-2 gap-6">
              {materials.map((m, i) => (
                <div key={m.t} className="flex gap-5 bg-[#f8f6f0] border border-[#a38e65]/25 p-6">
                  <span className="font-['Playfair_Display',serif] text-[#a38e65] text-2xl leading-none shrink-0 pt-0.5">{String(i + 1).padStart(2, '0')}</span>
                  <div>
                    <h3 className="jba-display font-medium text-[#1a2942] text-base sm:text-lg mb-2 leading-[1.5]">{m.t}</h3>
                    <p className="font-['Noto_Serif_JP',serif] text-sm text-[#4a4638] leading-[1.9]">{m.d}</p>
                  </div>
                </div>
              ))}
            </div>
            <div className="mt-6 bg-[#1a2942] px-7 sm:px-10 py-7 flex flex-col sm:flex-row sm:items-center gap-4 sm:gap-7">
              <span className="font-['Playfair_Display',serif] italic text-[#d7b779] text-sm tracking-[0.06em] shrink-0">Special Bonus</span>
              <div>
                <h3 className="jba-display font-medium text-[#f8f6f0] text-lg mb-1">執事サロン3時間 無料体験チケット</h3>
                <p className="font-['Noto_Serif_JP',serif] text-sm text-[#ded8cc] leading-[1.9]">お台場の執事サロンで、実際の執事サービスを体験できる特別チケット（30,000円相当）。上級の学びをいっそう深められます。</p>
              </div>
            </div>
          </section>

          <section>
            <SecHead roman="VI" en="Certification Exam">試験は、<span className="text-[#a38e65]">ご自宅で</span>受けられます</SecHead>
            <div className="grid lg:grid-cols-[1fr_320px] gap-8 lg:gap-12 items-start">
              <dl className="border-t-2 border-[#1a2942]">
                {examRows.map(([label, value]) => (
                  <div key={label} className="flex flex-col sm:flex-row gap-1 sm:gap-6 border-b border-[#e2ddd2] py-4">
                    <dt className="sm:w-[110px] sm:shrink-0 font-['Noto_Serif_JP',serif] text-sm text-[#8f7a56] tracking-[0.06em] pt-0.5">{label}</dt>
                    <dd className="flex-1 font-['Noto_Serif_JP',serif] text-[15px] sm:text-base text-[#1a2942] leading-[1.85]">{value}</dd>
                  </div>
                ))}
              </dl>
              <div className="lg:pt-1">
                <img
                  src="/images/generated/jba-fs-175-qualifications_professional-butler-v7.webp"
                  alt="認定証と認定カード。合格者に発行される証"
                  className="w-full h-56 lg:h-[300px] object-cover border border-[#a38e65]/30 mb-4"
                />
                <p className="font-['Noto_Serif_JP',serif] text-sm text-[#4a4638] leading-[1.9]">
                  受験には Associate Butler 資格の保持が必要です。ケーススタディを含む筆記試験を自宅で受け、解答用紙を返送。80点以上で合格し、認定証と認定カードを発行します。
                </p>
              </div>
            </div>
          </section>

          {/* VII. 三段階の階梯（現在地=professional）= 新バリエーション③。由来注記: overview S5 タイムライン文法を資格ステッパーへ翻案 */}
          <section>
            <SecHead roman="VII" en="The Three Tiers">資格は、<span className="text-[#a38e65]">三段階</span>で高めていく</SecHead>
            <p className="font-['Noto_Serif_JP',serif] text-base text-[#333] leading-[1.95] max-w-3xl mb-8">
              執事資格は、初級 Associate Butler から、中級 Professional Butler、上級 Master Butler へと段階的に取得します。飛び級での受験はできません。Professional Butler を修めた先には、指導と統括を担う最高位 Master Butler への道が続きます。
            </p>
            <ol className="border-t border-[#e2ddd2]">
              {ladder.map((t) => {
                const current = t.key === 'professional';
                return (
                  <li key={t.key} className={current ? 'bg-[#1a2942] border-b border-[#e2ddd2]' : 'border-b border-[#e2ddd2]'}>
                    <a href={t.href} className={`flex flex-wrap items-center gap-x-6 gap-y-2 px-5 sm:px-7 py-5 group ${current ? '' : 'hover:bg-[#f8f6f0]'} transition-colors duration-300`}>
                      <span className={`font-['Playfair_Display',serif] text-2xl w-8 shrink-0 ${current ? 'text-[#d7b779]' : 'text-[#a38e65]'}`}>{t.roman}</span>
                      <div className="min-w-[210px]">
                        <span className={`block jba-display text-lg ${current ? 'text-[#f8f6f0]' : 'text-[#1a2942]'}`}>{t.name}{current && <span className="ml-3 align-middle text-[10px] font-['Noto_Serif_JP',serif] tracking-[0.14em] text-[#1a2942] bg-[#d7b779] px-2 py-0.5">現在ご覧のページ</span>}</span>
                        <span className={`block font-['Noto_Serif_JP',serif] text-xs mt-0.5 ${current ? 'text-[#c9c2b4]' : 'text-[#8f7a56]'}`}>{t.ja}・{t.level}</span>
                      </div>
                      <span className={`jba-display text-xl ml-auto ${current ? 'text-[#d7b779]' : 'text-[#1a2942]'}`}>{t.price}<span className={`text-xs ml-1 ${current ? 'text-[#c9c2b4]' : 'text-[#8f7a56]'}`}>円</span></span>
                      <span className={`font-['Noto_Serif_JP',serif] text-sm shrink-0 ${current ? 'text-[#d7b779]' : 'text-[#a38e65] group-hover:translate-x-1 transition-transform'}`}>{current ? '—' : '詳細を見る →'}</span>
                    </a>
                  </li>
                );
              })}
            </ol>
          </section>

          <section>
            <SecHead roman="VIII" en="Enrollment">受講のご案内</SecHead>
            <div className="bg-[#1a2942] border border-[#a38e65]/45 p-8 sm:p-10 lg:p-12">
              <div className="flex flex-wrap items-end gap-x-8 gap-y-3 mb-8 pb-8 border-b border-white/15">
                <div>
                  <span className="block font-['Playfair_Display',serif] uppercase tracking-[0.2em] text-[11px] text-[#d7b779] mb-1.5">Professional Butler ・ Fee</span>
                  <span className="jba-display text-white text-[34px] sm:text-[40px] leading-none">78,000<span className="text-lg text-[#d7b779] ml-1.5">円</span></span>
                  <span className="block font-['Noto_Serif_JP',serif] text-xs text-white/60 mt-1.5">税込・送料込 ／ 資格の有効期限なし</span>
                </div>
                <ul className="grid sm:grid-cols-2 gap-x-8 gap-y-1.5 flex-1 min-w-[260px]">
                  {['テキスト教材（約200ページ）', 'オンライン動画レッスン（1年間）', '実技練習用キット', '認定試験問題・解答用紙', '試験添削サービス', '認定証・認定カード', '執事サロン3時間無料体験'].map((x) => (
                    <li key={x} className="flex items-start gap-2 font-['Noto_Serif_JP',serif] text-[13px] text-[#e7e2d8] leading-[1.7]">
                      <span className="text-[#d7b779] text-[11px] pt-1" aria-hidden="true">◆</span>{x}
                    </li>
                  ))}
                </ul>
              </div>
              <p className="font-['Noto_Serif_JP',serif] text-base text-[#e7e2d8] leading-[1.95] max-w-3xl mb-8">
                実務で独り立ちできる力を、通信教育で着実に。ケーススタディを通じて現場の判断力を養い、独立した執事としての道を確かなものにします。ご不明な点は、お気軽にお問い合わせください。
              </p>
              <div className="flex flex-col sm:flex-row gap-4 sm:gap-6">
                <a href="/contact" className={BTN08_ON_NAVY}>受講を申し込む・相談する</a>
                <a href="/qualifications" className={BTN08_ON_NAVY}>資格制度の一覧に戻る</a>
              </div>
            </div>
            <p className="font-['Noto_Serif_JP',serif] text-xs text-[#8f7a56] leading-[1.9] mt-6 max-w-3xl">
              本資格は全日本執事協会が認定する民間資格です。受験には Associate Butler 資格の保持が必須です。資格取得により就職・転職・収入を保証するものではなく、知識習得と自己研鑽を目的とした学習プログラムです。
            </p>
          </section>

        </div>
      </div>
    </Layout>
  );
}
